import { ActionType } from '../reducers/cancellationVoucher';
import { api } from '../config';
import mockData from '../mocks/cancellationVoucherPdf.json';

export const setCancellationVoucherData = (orderAttemptId) => {
  return (dispatch) => {
    const shouldFetchMock = false;
    const fetchType = shouldFetchMock ? 'FETCH_MOCK' : 'FETCH';
    const mockResult = mockData;

    const rand = Math.random() * 10000000000000000;
    const url = `${api.cancellationVoucher.get}/${orderAttemptId}?rand=${rand}`;
    const method = 'get';

    const type: ActionType = 'SET_CANCELLATION_VOUCHER_DATA';
    return Promise.resolve(
      dispatch({
        type,
        fetch: {
          type: fetchType,
          actionTypes: {
            request: 'REQUEST_CANCELLATION_VOUCHER_DATA',
            success: 'RECEIVED_CANCELLATION_VOUCHER_DATA',
            fail: 'ERROR_CANCELLATION_VOUCHER_DATA',
          },
          url,
          mockResult,
          method,
        },
      }),
    );
  };
};
